import { DISPLAY_NOT_FOUNT_ELEMENT } from 'src/redux/constants/notFoundConstants'
import { AppDispatch } from 'src/redux/store'

export const displayNotFoundElement = (displayed: boolean) => (dispatch: AppDispatch) => {
  dispatch({ type: DISPLAY_NOT_FOUNT_ELEMENT, payload: displayed })
}
